import React from "react";
import { Button } from "react-blueprint-library";
import "./NavigationButtons.scss";

const NavigationButtons = ({
  bckbtnid,
  nxtbtnid,
  onBack,
  onNext,
  isLoading,
  isDisabled,
  isFinOnly = false,
  nextBtnText = "Next",
  backBtnText = "Back",
  reverseBtnOrder = false,
}) => {
  const disabled = isDisabled !== undefined ? isDisabled : isLoading;
  return (
    <section
      id="pageNavigationButtons"
      className={reverseBtnOrder ? "row reverse" : "row"}
    >
      <div className="col-sm-12">
        {reverseBtnOrder ? (
          <>
            <button
              type="button"
              className={`btn ${isLoading ? "btn-primary-loading" : "btn-primary"}`}
              onClick={onNext}
              disabled={disabled}
              id={nxtbtnid}
            >
              {!isLoading ? <>{nextBtnText}</> : <></>}
            </button>
            {!isFinOnly && onBack && bckbtnid && (
              <Button
                id={bckbtnid}
                type="button"
                variant={"tertiary"}
                onClick={onBack}
              >
                <strong>{backBtnText}</strong>
              </Button>
            )}
          </>
        ) : (
          <>
            {!isFinOnly && onBack && bckbtnid && (
              <Button
                id={bckbtnid}
                type="button"
                variant={"tertiary"}
                onClick={onBack}
              >
                <strong>{backBtnText}</strong>
              </Button>
            )}
            <button
              type="button"
              className={`btn ${isLoading ? "btn-primary-loading" : "btn-primary"}`}
              onClick={onNext}
              disabled={disabled}
              id={nxtbtnid}
            >
              {!isLoading ? <>{nextBtnText}</> : <></>}
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default NavigationButtons;
